/**
 * Контекстні підказки «?» режиму навчання: коротке пояснення правила фірми біля місця, де воно діє.
 * Використання: <HelpHint id="task.reason" />.
 */

export type HintId =
  | 'my-work.sections'
  | 'task.assignee'
  | 'task.due'
  | 'task.reason'
  | 'task.result'
  | 'task.sensitive'
  | 'board.limits'
  | 'board.checks'
  | 'list.bulk'
  | 'time.description'
  | 'time.timer'
  | 'inbox.zero';

export type Hint = { title: string; text: string };

export const HINTS: Record<HintId, Hint> = {
  'my-work.sections': {
    title: 'Групи за строком',
    text: 'Задачі розкладено за строками: прострочені, сьогодні, цей тиждень, пізніше, без строку. Прострочену задачу перенесіть із причиною або завершіть із результатом.',
  },
  'task.assignee': {
    title: 'Один виконавець',
    text: 'У задачі один відповідальний виконавець. Колег, які допомагають, додайте учасниками — вони отримуватимуть сповіщення. Зміна виконавця — з причиною.',
  },
  'task.due': {
    title: 'Обов’язковий строк',
    text: 'Строк потрібен для кожної задачі, крім етапів, де його дозволено не вказувати. Доручення колезі після 15:00 система запропонує поставити на наступний робочий день.',
  },
  'task.reason': {
    title: 'Причина перенесення',
    text: 'Перенесення строку чи зміна виконавця потребує причини. Вона фіксується в історії змін і коментарях — керівник бачить, чому план змінився.',
  },
  'task.result': {
    title: 'Результат під час завершення',
    text: 'Коротко опишіть, що зроблено й де лежить результат: документ, посилання, рішення. Без опису результату задачу не буде завершено.',
  },
  'task.sensitive': {
    title: 'Чутливі дані',
    text: 'Не вставляйте в описи й коментарі номери карток, IBAN чи паролі — система попередить про такі дані. Передавайте їх захищеними каналами фірми.',
  },
  'board.limits': {
    title: 'Ліміт робіт і норматив',
    text: '2/3 — відкриті задачі проти ліміту етапу. «5 год» — норматив перебування задачі на етапі в робочих годинах. Досягли ліміту — спершу завершіть роботу на етапі.',
  },
  'board.checks': {
    title: 'Контрольні питання етапу',
    text: 'Під час переходу на деякі етапи система запитає контрольні питання чи обов’язкові поля. Це перевірка готовності роботи, а не формальність.',
  },
  'list.bulk': {
    title: 'Дії з кількома задачами',
    text: 'Позначте задачі, щоб змінити етап, виконавця чи строк разом. Правила діють і тут: перенесення строку й зміна виконавця — з причиною.',
  },
  'time.description': {
    title: 'Опис запису часу',
    text: 'Стандарт — «об’єкт_дія в минулому часі», наприклад «Договір оренди_перевірив(ла) й надіслав(ла) правки». Під час запуску з картки задачі об’єкт підставляється з її назви.',
  },
  'time.timer': {
    title: 'Один таймер',
    text: 'Одночасно працює один таймер: запуск нового зупиняє попередній. Обід і святкування не трекаються.',
  },
  'inbox.zero': {
    title: 'Нуль непереглянутих',
    text: 'Правило фірми: на 11:00 понеділка у вхідних не лишається непереглянутих сповіщень. Позначте прочитане або перетворіть сповіщення на дію.',
  },
};

export function getHint(id: string): Hint | undefined {
  return Object.prototype.hasOwnProperty.call(HINTS, id) ? HINTS[id as HintId] : undefined;
}
